import React, { useRef, useState } from 'react';
// Import Swiper React components


// Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

// import './styles.css';

// import required modules
import { FreeMode, Navigation, Thumbs } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Box } from '@mui/material';
import ModalComponent from './ModalComponent';

export default function LightBox({ showLightBox, setShowLightBox, propInfo }) {
    const [thumbsSwiper, setThumbsSwiper] = useState(null);

    return (
        <ModalComponent showModalState={showLightBox}
            handleModalClose={() => setShowLightBox(false)}
            modalTitle=""
            disableSubmitBtn={true}
            hasSpecificParent={true}
            modalSubmitBtn={() => { }}>
            <Box>
                <Swiper
                    style={{
                        '--swiper-navigation-color': '#fff',
                        '--swiper-pagination-color': '#fff',
                    }}
                    loop={true}
                    spaceBetween={10}
                    navigation={true}
                    thumbs={{ swiper: thumbsSwiper }}
                    modules={[FreeMode, Navigation, Thumbs]}
                    className="lightbox"
                >
                    {propInfo.Pictures.map((item, index) => {
                        return <SwiperSlide key={index}>
                            <img src={`https://ws.iranamlaak.net/upload/property/${propInfo.RegistrarAgency}/${propInfo.Id}/${item}`} className="lightBox-img" />
                        </SwiperSlide>
                    })}
                </Swiper>
                <Swiper
                    onSwiper={setThumbsSwiper}
                    loop={true}
                    spaceBetween={10}
                    slidesPerView={4}
                    freeMode={true}
                    watchSlidesProgress={true}
                    modules={[FreeMode, Navigation, Thumbs]}
                    className="mySwiper"
                >
                    {propInfo.Pictures.map((item, index) => {
                        return <SwiperSlide key={index}>
                            <img src={`https://ws.iranamlaak.net/upload/property/${propInfo.RegistrarAgency}/${propInfo.Id}/${item}`} style={{width:"100%",height:"110px"}} />
                        </SwiperSlide>
                    })}
                </Swiper>
            </Box>
        </ModalComponent>
    );
}
